module.exports = __webpack_public_path__ + "static/goodbye-39e70292c3754f2032740731ed9e2167.gif";